import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
          内容分类
        </h2>
        <p className="text-sm md:text-base text-foreground-500">
          八大品类，应有尽有，总有一款适合你
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 text-center hover:border-primary-300 hover:bg-primary-50/50 transition-all"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 bg-primary-50 rounded-xl flex items-center justify-center group-hover:bg-primary-100 transition-colors">
              <i className={`${cat.icon} text-primary-500 text-xl md:text-2xl`}></i>
            </div>
            <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1">
              {cat.name}
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed hidden sm:block">
              {cat.description}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}